"use client";

import { useTranslator } from "~/i18n/provider";

/**
 * P2-09 · PLP inline error boundary: the listing query failed, but the page
 * chrome (header/footer) stays usable and the shopper can retry in place.
 */
export default function CategoryError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslator();
  return (
    <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-4 py-16 text-center">
      <h1 className="font-heading text-xl font-semibold text-fg">
        {t("browse.loadFailedTitle")}
      </h1>
      <p className="max-w-md text-sm text-fg-muted">
        {t("browse.loadFailedBody")}
      </p>
      <button
        type="button"
        onClick={reset}
        className="rounded-[var(--btn-radius)] bg-primary px-4 py-2 text-sm text-primary-fg [font-weight:var(--btn-weight)] hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)]"
      >
        {t("common.tryAgain")}
      </button>
    </div>
  );
}
